import React, { Fragment } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Tooltip } from '@ontruck/orc';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { Logs } from 'modules/log';

const StyledIncidentCell = styled.span`
  width: ${(props) => props.theme.base.gridSizes.M};
  height: ${(props) => props.theme.base.gridSizes.M};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border: 1px solid var(--greyWolf);
  }
`;

const enhance = compose(injectIntl);

const IncidentsCell = React.memo(
  ({
    numberOfIncidents,
    shipperOrderId,
    fullText = true,
    intl,
    shipper_orders_skin,
    className,
  }) => {
    const t = intl.messages.components.JourneyCard;

    const Total = fullText ? (
      <Fragment>{numberOfIncidents}</Fragment>
    ) : (
      <StyledIncidentCell>{numberOfIncidents}</StyledIncidentCell>
    );

    return (
      !!numberOfIncidents && (
        <Fragment>
          <Tooltip
            component={
              <Logs
                shipperOrderId={shipperOrderId}
                showTitle={false}
                reduced
                shipperOrdersSkin={shipper_orders_skin}
              />
            }
            position="bottom"
            skin="light"
            tooltipClassName={className}
          >
            {Total}{' '}
            {fullText && (
              <FormattedMessage
                id="IncidentsCell.incidents"
                defaultMessage={t.incidents}
                values={{ number: numberOfIncidents }}
              />
            )}
          </Tooltip>
        </Fragment>
      )
    );
  }
);

const IncidentsCellStyled = styled(IncidentsCell)`
  padding: 0;
`;

IncidentsCell.propTypes = {
  number_of_incidents: PropTypes.num,
  fullText: PropTypes.bool,
  modelType: PropTypes.string,
  item: PropTypes.shape({}),
  intl: PropTypes.any,
};

export default enhance(IncidentsCellStyled);
